import styles from './MobileAppDevelopment.module.scss'
import FV from './FV'
import Issue from './Issue'
import Team from './Team'
import Flow from './Flow'
import CtaMiddle from './CtaMiddle'
import Case from './Case'
import { Contact } from './Contact'
import Popup from 'components/common/PopupCTAMobileAppDevelopment/'

const ContactFormId = 'eb15d2f0-e197-4138-a9f8-237c678b3560'

const FlowContents = {
  items: [
    {
      num: '1',
      title: '戦略立案・企画設計',
      description: (
        <>
          ビジネスゴール、ターゲットユーザー、KPIを明確化し、
          <br />
          「なぜアプリが必要なのか」「どんな体験を提供すべきか」を定義します。
        </>
      ),
      planItems: [
        '業界・市場調査にもとづく戦略立案',
        '競合分析・ユーザーインサイトの整理',
        'MVP（最小実行可能プロダクト）設計とロードマップ策定',
      ],
    },
    {
      num: '2',
      title: 'UX／UI設計',
      description: (
        <>
          ユーザー体験の質が、アプリの価値を決めます。
          <br />
          i3DESIGNでは、UXリサーチから情報設計、UIデザインまでを一気通貫で実施。
          <br />
          デザイナーとエンジニアが密に連携し、「見た目」だけでなく「使いやすさ」「継続利用」を設計します。
        </>
      ),
      planItems: ['ペルソナ/カスタマージャーニー作成', 'プロトタイプ検証・ユーザーテスト'],
    },
    {
      num: '3',
      title: '開発・品質保証・ストア申請',
      description: (
        <>
          開発フェーズでは、モダンな技術基盤と柔軟な開発体制でスピードと品質を両立。
          <br />
          Flutter/React Nativeなどのクロスプラットフォーム開発、
          <br />
          AWSやGCPを用いたクラウドネイティブ構成、CI/CD導入による継続デリバリーまで、エンタープライズ品質のモバイル開発を実現します。
        </>
      ),
      planItems: [
        'ネイティブ・クロスプラットフォーム開発対応',
        'API連携・認証など高セキュリティ要件にも対応',
        'ストア申請支援・リジェクト回避ノウハウ提供',
      ],
    },
    {
      num: '4',
      title: 'リリース後の運用・グロース支援',
      description: (
        <>
          アプリの価値は、リリース後に決まります。
          <br />
          i3DESIGNでは、継続的なデータ分析と改善提案を通じて、
          <br />
          アプリがビジネス成長を生み出す状態を維持します。
        </>
      ),
      planItems: [
        '定量・定性データに基づくUX改善サイクル',
        'プッシュ通知、ASO、機能A/Bテストなどのマーケティング支援',
        'ユーザー行動データの活用によるグロース設計',
        '定期的な振り返り・レポートによる伴走支援',
      ],
    },
  ],
}

const MobileAppDevelopment: React.FC = () => {
  return (
    <div className={styles.resetMobileApp}>
      <FV />
      <Issue />
      <Team />
      <Flow contents={FlowContents} />
      <CtaMiddle />
      <Case />
      <Contact formId={ContactFormId} />
      <article>
        <Popup />
      </article>
    </div>
  )
}
export default MobileAppDevelopment
